module.exports = __webpack_public_path__ + "img/2019_11_6.fb423d9c.jpg";